import { render, staticRenderFns } from "./PerformanceCrowdSelectionListSkeleton.vue?vue&type=template&id=1517632c&"
import script from "./PerformanceCrowdSelectionListSkeleton.vue?vue&type=script&lang=js&"
export * from "./PerformanceCrowdSelectionListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceCrowdSelectionListSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports